import { DateFormat, Trans } from '@lingui/macro'
import { CircularProgress, colors } from '@material-ui/core'
import { Cancel, Check } from '@material-ui/icons'
import React from 'react'

export enum ECredentialStatus {
  UNKNOWN,
  VERIFYING,
  INVALID,
  VERIFIED,
}

interface IProps {
  status: ECredentialStatus
  verifiedAt?: Date
}

export const CredentialsStatus: React.FC<IProps> = ({ status, verifiedAt }) => {
  let color: string
  let icon: ReactNode
  let msg: ReactNode
  switch (status) {
    case ECredentialStatus.VERIFYING:
      color = colors.grey[400]
      icon = <CircularProgress size="1rem" />
      msg = <Trans>Ověřování...</Trans>
      break
    case ECredentialStatus.INVALID:
      color = colors.red[400]
      icon = <Cancel />
      msg = <Trans>Údaje nejsou platné</Trans>
      break
    case ECredentialStatus.VERIFIED:
      color = colors.green[400]
      icon = <Check />
      msg = (
        <Trans>
          Ověřeno <DateFormat value={new Date(verifiedAt!)} />
        </Trans>
      )
      break
    default:
      return null
  }
  return (
    <span style={{ color }}>
      {icon}
      {msg}
    </span>
  )
}
